// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1oCuj","tab":"Tabs_tab__186XJ","tabActive":"Tabs_tabActive__31Lbl"};